import { Edit } from "lucide-react"
import { Button } from "@/components/ui/button"

interface ProfileHeaderProps {
  isEditing: boolean
  onEditClick: () => void
}

export function ProfileHeader({ isEditing, onEditClick }: ProfileHeaderProps) {
  return (
    <div className="flex flex-col items-center w-full space-y-4">
      <h2 className="text-2xl font-bold tracking-tight text-primary">Perfil</h2>
      <Button
        variant="outline"
        size="sm"
        onClick={onEditClick}
        className="flex items-center gap-2 px-4 py-2 transition-all duration-200 hover:scale-105 hover:shadow-md border-primary/20 hover:border-primary/40"
      >
        <Edit className="h-4 w-4 text-primary" />
        <span className="text-sm font-medium">
          {isEditing ? "Cancelar edição" : "Editar perfil"}
        </span>
      </Button>
    </div>
  )
}